export default __webpack_public_path__ + "static/media/Group 1683.8bda3a19.svg";